import React, { useEffect, useState } from 'react';
import './css_files/registration.css'
import { Link, useNavigate } from 'react-router-dom';
import { Radio } from '@mui/material';
import { SelectPriceTypeModal } from './modals/select-price-type-modal';

const RegisterCard = (props) => {

    const navigate = useNavigate()
    const [priceType, setPriceType] = useState()
    const [open, setOpen] = useState(false)
    const [url, setUrl] = useState("")

    const handleSubmit = () => {
        console.log('button pressed')
        if (!priceType){
            setOpen(true)
        }
        else{
            navigate(url)

        }
    }

    useEffect(()=>{
        if(priceType == "domestic"){
            setUrl(`/dog_registrations/${props.text_price}`)
        }
        if (priceType == "international"){
            setUrl(`/dog_registrations/${props.text_price2}`)
        }
    }, [priceType])

    return (
        <div className={`row align-items-center justify-content-center ${props.specialClasses}
        register-card-main px-5 px-sm-0`} >


            <div class={`col-md-4 
            ${props.shiftRight} 
            ${props.yellowLightBg} align-items-center align-items-sm-start  
            justify-content-center text-left`}>
                <img class={`register-image-before ${props.className}`}
                    src={props.image_src}
                    alt="Card image cap"></img>

            </div>
            {props.specialEvent ?
                <div className='col-md-10 align-items-center align-items-sm-start justify-content-center text-left '>
                    <div class="border-yellow  mt-4 mt-sm-0 mb-4 mb-sm-4">
                        <h1 class={` text-black font-weight-bold specialEventFont  text-uppercase ${props.titleClassName}`}>{props.title}</h1>
                    </div>
                    <h5 class="specialEventFont font-weight-bold" style={{ fontSize: '' }}>{props.text1}</h5>

                    <p class="m-0 " style={{ fontSize: '1rem' }}>{props.text2}</p>

                    {props.text_price && <p class="specialEventFont my-3 font-weight-bold">Price :
                        <span className='  '> ${props.text_price}</span></p>}
                   

                    <a href={props.url} class="brand-yellow-font  text-uppercase font-weight-bold "><h3
                        className='pt-2 specialEventFont   text-warning font-weight-bolder'>Register</h3></a>
                </div>
                :
                <div className='col-md-5 order-2 align-items-center
                 align-items-sm-start justify-content-center 
                 text-left specialEventText'>

                    <div class="border-yellow  mt-4 mt-sm-0 mb-4 mb-sm-4">
                        <h5 class={` text-black font-weight-bold   text-uppercase ${props.titleClassName}`}>{props.title}</h5>
                    </div>
                    <p class="m-0" style={{ fontSize: '1rem' }}>{props.text1}</p>

                    <p class="m-0" style={{ fontSize: '1rem' }}>{props.text2}</p>

                    {props.text_price && <span class="mt-1 mb-0">Price :
                        <input type="radio" id="html" name="priceType" value="price"
                            className='radio-register mt-4'
                            onChange={e => setPriceType("domestic")}
                            ></input>

                        <span className='  font-weight-bold'> ${props.text_price}
                            <span className='font-weight-normal brand-yellow-font font-footer'> DOMESTIC</span></span></span>}

                    {props.text_price && <span class="d-block mt-1 mb-0"><span style={{ visibility: "hidden" }}>Price: </span>
                        <input type="radio" id="html" name="priceType"
                            value="international" 
                            onChange={e => setPriceType("international")}

                            className='radio-register my-1'></input>

                        <span className='  font-weight-bold'> ${props.text_price2}
                            <span className='font-weight-normal brand-yellow-font font-footer'> INTERNATIONAL</span></span></span>}




                    <button onClick={handleSubmit}href={props.url} class="
                     register-card-button  mt-3 text-center  px-5 py-2">Register</button>

                </div>
            }

               {open &&  <SelectPriceTypeModal 
            title={props.title}
               open={open} domesticPrice={props.text_price}
                internationalPrice={props.text_price2} url={url}
                />
        }
        </div>









    )
}



export default RegisterCard;